import React from "react";
import { useTranslation } from "react-i18next";
import AccordionBox from "components/Layouts/AccordionBox";
import SimpleDataTable from "components/Modules/SimpleDataTable";

const LoggedInUsers = ({ usersList, isLoading, customCaptions }) => {
	const { t } = useTranslation();
	return (
		<AccordionBox
			title={t("label.webApplicationEntity", {
				entity: customCaptions?.userPlural ?? "Users",
			})}
			accordianDetailsCss="siteDetailTableContainer"
		>
			<SimpleDataTable
				isLoading={isLoading}
				data={usersList}
				tableHeaders={[
					t("label.firstName"),
					t("label.lastName"),
					t("label.loginDate"),
				]}
			/>
		</AccordionBox>
	);
};

export default LoggedInUsers;
